import axios from 'axios'
import { LOCAL_STORAGE } from '../utils/constants'

const allAxiosCommonRequest = async function (props = {}) {
    let token = LOCAL_STORAGE.userToken
    let userId = LOCAL_STORAGE.userId
    let customerNo = LOCAL_STORAGE.customerNo
    let congData =
    {
        //customerNo: customerNo,
        //customerNumber: customerNo,
        //userId: userId,
        ...props.Items
    }
    let response = 
    /* await axios.post("https://dev-scctgateway.elixia.tech/transporter-allocation/aws/dashboard", {
            "dashboard_id": "3d22e4ce-b8e4-4310-81ab-f68fd4be003a"
        }) */
    await axios.request({
        baseURL: `${process.env.REACT_APP_SCCT_BASE_URL}/transporter-allocation`,
        url: '/aws/dashboard',
        method: props.method,
        data: props.method != 'get' ? congData : '',   
    })
    let resp = new Promise((resolve, reject) => {
        if (response.status === 200) {
            resolve(response)
        } else {
            reject(response)
        }
    })
    return resp;
}
export default allAxiosCommonRequest